import _extends from "@babel/runtime/helpers/esm/extends";
import { GridWorkspacesIcon, GridGroupWorkIcon, GridFunctionsIcon } from './icons';
const iconsSlots = {
  ColumnMenuUngroupIcon: GridWorkspacesIcon,
  ColumnMenuGroupIcon: GridGroupWorkIcon,
  ColumnMenuAggregationIcon: GridFunctionsIcon
};
const materialSlots = _extends({}, iconsSlots);
export default materialSlots;